import React from "react";
import { Controller } from "react-hook-form";
import { get } from "lodash";
import moment from "moment";
import clsx from "clsx";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import { CalendarIcon } from "../../../../icons";

const DatePickerField = (props) => {
  const { name, control, disabled } = props;

  return (
    <div>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value }, formState: { errors } }) => {
          const errorMsg = get(errors, `${name}.message`, null);

          const formatDate = (date) => {
            if (date) {
              let dateObj;

              if (
                date &&
                typeof date === "object" &&
                date.day &&
                date.month &&
                date.year
              ) {
                dateObj = new Date(`${date.year}-${date.month}-${date.day}`);
              } else if (date instanceof Date) {
                dateObj = date;
              } else {
                return "";
              }

              const formatDate = moment(dateObj).format("DD MMMM YYYY");
              return formatDate;
            }

            return ``;
          };

          const formatInputValue = () => {
            if (!value) return disabled ? "" : "DD MM YYYY";

            return `${formatDate(value)}`;
          };

          return (
            <>
              <div
                id="dateRangeSelector"
                className={`relative w-full h-full max-h-12 z-[1] ${
                  disabled
                    ? "pointer-events-none !bg-quartenary rounded-md"
                    : ""
                }`}
              >
                <DatePicker
                  disabled={disabled}
                  value={value}
                  formatInputText={formatInputValue}
                  onChange={disabled ? undefined : onChange}
                  locale="en"
                  colorPrimary={"#5ABC99"}
                  colorPrimaryLight={"#79C8B040"}
                  inputPlaceholder={disabled ? " " : "Date"}
                  inputClassName={`w-full h-12 !p-2 !pt-3 !pb-0 rounded !border-1 !font-normal !text-sm leading-4 focus:outline-none focus:border-vekin hover:outline-none hover:border-vekin-green40 !text-start ${clsx(
                    {
                      "!border-[#ED1C24]": errorMsg,
                      "!text-vekin-green100": value,
                      "!text-tertiary": !value,
                      "!bg-quartenary !text-vekin/70": disabled,
                      "cursor-pointer bg-white": !disabled,
                    }
                  )}`}
                  wrapperClassName="w-full h-full"
                />

                {/* calendar icon */}
                {!disabled && (
                  <div className="absolute top-[18px] right-2 rounded-lg z-[999999]">
                    <img src={CalendarIcon} alt="calendarIcon" />
                  </div>
                )}
              </div>
              {errorMsg ? (
                <label className="label !py-1 text-vekin-message-error">
                  <span className="label-text-alt text-vekin-message-error">
                    {errorMsg}
                  </span>
                </label>
              ) : null}
            </>
          );
        }}
      />
    </div>
  );
};

export default DatePickerField;
